module.exports = __webpack_public_path__ + "img/confirmacao-hero.2f11d3b5.jpg";